import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { CryptoService } from 'src/app/services/crypto.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-category-searchbar',
  templateUrl: './category-searchbar.component.html',
  styleUrls: ['./category-searchbar.component.scss']
})
export class CategorySearchbarComponent {


  @Input() colors: string[] = ['#300a3b', '#2a0450', '#082f4e', '#011941', '#110d49'];

  @Input() searchText = '';

  @Input() ou?: number;


  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");


  recentsearches: any = []

  showItems = true;
  parents: OrganizationUnit[] = [];
  count: number = 0;
  searchQueryObject: any;
  currentOu: any;

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute, private cryptoService: CryptoService,) { }

  async ngOnInit() {
    this.fetchRecentSearches();
    console.log("parents", this.parents);
    if (this.searchText == 'all') {
      this.searchText = ''
    } else {
      try {
        // If searchText is URI-encoded, decode it
        if (this.searchText !== decodeURI(this.searchText)) {
          this.searchText = decodeURI(this.searchText);
        }
      } catch (e) {
        // If decodeURI fails (malformed URI), leave searchText as is
      }
    }

    this.currentOu = await this.getById();

    this.route.queryParams.subscribe(async (params) => {
      this.searchQueryObject = decodeURI(params['query']);
    });
  }

  async fetchRecentSearches() {
    try {
      let res = await this.dataService.getData('ou/search-history');
      console.log("RES", res);
      this.recentsearches = res.data.reverse();
      if (this.recentsearches.length > 10) {
        this.recentsearches = this.recentsearches.splice(0, 10)
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getById() {
    try {
      let res = await this.dataService.getData('ou/byId?id=' + this.ou);
      console.log("RES", res);
      while (res.data[0].parent != null && res.data[0].type != "64648e7118d4943a0a7b366c") {
        if (res.data[0].parent.id) {
          res = await this.dataService.getData('ou/byId?id=' + res.data[0].parent.id);
        } else {
          res = await this.dataService.getData('ou/byId?id=' + res.data[0].parent);
        }
      }
      return res.data[0];
    } catch (e) {
      console.log(e);
    }
  }

  gotoAdvanceSearch(arg0: any) {
    let queryParams = { query: this.searchQueryObject };
    this.router.navigate(['/advance-search'], { queryParams }).then(() => {
      // Force a full page reload after the route change is complete
      location.reload();
    });
  }



  navigateToSearch(event: any) {
    let term = event.target.value;
    if (term == '') {
      term = 'all'
    }
    if (term.includes("\"") || term.includes("+") || term.includes("-")) {
      this.advancedSearch(term);
      return;
    }

    
    if (this.ou) {
      let queryParams = { ou: this.ou, searchTerm: encodeURI(term) };
      this.router.navigate(['/search-view'], { queryParams }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });
    } else {
      let queryParams = { searchTerm: encodeURI(term) };
      this.router.navigate(['/search-view'], { queryParams }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });
    }
    this.ngOnInit();
  }

  advancedSearch(search: string) {
    let query: any = { condition: 'and', rules: [] };
    query.extras = this.extractSearchParts(search);
    let encryptedQuery = this.cryptoService.encodeObject(query);
    let params = { query: encryptedQuery };
    this.router.navigate(['/advance-search/result'], { queryParams: params })
  }

  extractSearchParts(search: string) {
    let removal: string[] = [];
    let exact: string[] = [];
    let any: string[] = [];

    // Extract exact match parts
    search = search.replace(/"(.*?)"/g, (_, match) => {
      exact.push(match);
      return ""; // Remove from original string
    });

    // Extract removal parts (after '-')
    search = search.replace(/-(\S+)/g, (_, match) => {
      removal.push(match);
      return ""; // Remove from original string
    });

    // Remaining parts (any match) after removing '+' and trimming
    const remainingParts = search.replace(/\+/g, "").trim();
    if (remainingParts) {
      any.push(...remainingParts.split(/\s+/));
    }
    let query: any = {
      likeAll: any.join(" "),
      sameWord: exact.join(" ").replaceAll("+", ""),
      notContains: removal.join(" ").replaceAll("+", "")
    }
    if (exact.length == 0) {
      delete query.sameWord;
    }

    if (any.length == 0) {
      delete query.likeAll;
    }

    if (removal.length == 0) {
      delete query.notContains;
    }
    return query;
  }

  staticURL = GlobalConstants.staticFilesURL;

}
